import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import Search from 'components/UI/PageSearch'
import UsersTable from './components/Table'
import UsersFilter from 'components/PageComponents/Settings/Users/Register/components/Filter'
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
// view
import { CreateUserButton } from 'components/CTAs/index'
// context
import { UsersPageContext } from 'containers/Users/layers/API'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Users: React.FC = () => {
  const { isAdmin } = useCurrentUser()

  const { isLoading } = React.useContext(UsersPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - User Settings</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <Search name={'name'} filter={UsersFilter} initialValues={{ active: true }} />
            <CreateUserButton />
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <UsersTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Users
